var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.529 112.941V82.823c0-33.267 26.968-60.235 60.235-60.235h120.471c33.267 0 60.235 26.968 60.235 60.235v30.118h75.294c33.267 0 60.235 26.968 60.235 60.235v256c0 33.267-26.968 60.235-60.235 60.235H60.235C26.968 489.411 0 462.443 0 429.176v-256c0-33.267 26.968-60.235 60.235-60.235h75.294zm346.353 110.43v-50.195c0-16.634-13.484-30.118-30.118-30.118H376.47v30.118c0 8.317-6.742 15.059-15.059 15.059s-15.059-6.742-15.059-15.059v-30.118H165.647v30.118c0 8.317-6.742 15.059-15.059 15.059s-15.059-6.742-15.059-15.059v-30.118H60.235c-16.633 0-30.118 13.484-30.118 30.118v50.195c66.136 26.747 141.4 40.158 225.882 40.158s159.748-13.411 225.883-40.158zm0 32.334C414.808 281.021 339.488 293.647 256 293.647S97.192 281.021 30.118 255.705v173.472c0 16.634 13.484 30.118 30.118 30.118h391.529c16.633 0 30.118-13.484 30.118-30.118V255.705zM165.647 112.941h180.706V82.823c0-16.634-13.484-30.118-30.118-30.118h-120.47c-16.633 0-30.118 13.484-30.118 30.118v30.118zM210.824 384c-8.317 0-15.059-6.742-15.059-15.059s6.742-15.059 15.059-15.059h90.353c8.317 0 15.059 6.742 15.059 15.059S309.493 384 301.176 384h-90.352z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateservice);
export default __webpack_public_path__ + "static/media/corporateservice.4141920e7d05d9972a9688fc385c6c99.svg";
export { ForwardRef as ReactComponent };